module.exports = function() {
  return new Worker(__webpack_public_path__ + "9930866333a4b90e2f87.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/worker-loader/dist/cjs.js!./utils/scramble.worker.js
// module id = t75U
// module chunks = 2